import { LINKS } from '@/Module/Core/Constant';

export const prepareGradeUrlMenu = (seo_url_slug?: string) => {
  return LINKS.LESSONS.replace('[gradeSlug]', seo_url_slug ?? '');
};
